export const GL_TITLE = {en: "our gallery" , tr: "GALERİ"};

